const _fixedTypes = ['date', 'time', 'datetime', 'text', 'select', 'number', 'label']
const _codeImgTypes = ['qrcode', 'code128', 'datamatrix', 'logo','urgent']
const _textTypes = ['date', 'time', 'datetime', 'text','serial_number']
const _specialTypes = ['list']

import { utilsObject } from "@/utils/utils.js"
import moment from "moment"

export default {
  generateTagHtml(template, data = [{}]) {
    // 按照数据生成标签打印html
    const { content, w, h } = template
    let string = ''
    data.forEach(d => {
      let pageString = '';
      content.forEach(i => {
        let elementString = '';
        const { type, conditions,printForm } = i
        let labelIdenCode = i.labelIdenCode ? i.labelIdenCode.split('/') : []
        let conditionResult = true
        let conditionExpressionString = ''
        if (conditions && conditions.length && Object.keys(d).length) {
          conditions.forEach((c, ci) => {
            const {
              conditionKey,
              valueKey,
              compareValue
            } = c
            if (ci > 0) {
              conditionExpressionString += c.connectorValue
            }
            const value = valueKey.type === 'label' ? valueKey.text : d[valueKey.key]
            conditionExpressionString += `'${this._extractDataValue(d, conditionKey.key)}'${compareValue}'${value}'`
          })

          conditionResult = eval(conditionExpressionString)
        }
        
        if (!conditionResult) return false
        if (printForm && _codeImgTypes.includes(printForm)) {
          // 二维码/条形码
          let value = undefined
          if (i.key == "labelIdenCode") {
            console.log(i);
            let string = ''
            // 标签识别码
            for (const stringItem of content) {
              if (labelIdenCode.includes(stringItem.key)) {
                string += stringItem.text
              }
            }
            console.log(string);
            value = utilsObject.generateCode(string, 'qrcode')
          }else{
            // 其他正常的
            value = utilsObject.generateCode(i.text, printForm)
          }
          elementString = value ? `<img style="position: absolute; width: ${i.width}px; height: ${i.height}px; left: ${i.x}px; top: ${i.y}px;" src="${value}" crossorigin=anonymous />` : ''
        }
        else  if (_fixedTypes.includes(type)) {
          let isDate = moment(i.text, '', true).isValid();
          if (type === 'datetime' && isDate) {
            if (i.formatValue) {
              i.text = moment(i.text).format(i.formatValue)
            }
          }
          // 固定文本
          elementString = `<div style="position: absolute; width: ${i.width}px; height: ${i.height}px; left: ${i.x}px; top: ${i.y}px;font-size: ${i.fontSize}px; font-weight: ${i.bold ? 'bold': 'normal'}; line-height: ${i.lineHeight}px;word-break:break-all;background-color: ${i.backColor ? '#000' : 'transparent'}; color: ${i.backColor ? '#fff' : '#000'}; text-align: ${i.textAlign || 'left'};">${i.text}</div>`
        } else if (_codeImgTypes.includes(type)) {
          // 图片类型
          const itemValue = Object.keys(d).length ? this._extractDataValue(d, i.key) : undefined
          const value = Object.keys(d).length ? Vue.prototype.$utils.generateCode(itemValue, type) : i.img;
          elementString = value ? `<img style="position: absolute; width: ${i.width}px; height: ${i.height}px; left: ${i.x}px; top: ${i.y}px;" src="${value}" crossorigin=anonymous />` : ''
        } else if (_textTypes.includes(type)) {
          // 文本类型
          let value = ''
          if (Object.keys(d).length) {
            const itemValue = this._extractDataValue(d, i.key)
            const dataValue = itemValue
            const dataValueArray = dataValue ? `${dataValue}`.split(' ') : []
            if (type === 'date') {
              value = dataValueArray[0] || ''
            } else if (type === 'time') {
              value = dataValueArray[1] || ''
            } else if (type === 'datetime') {
              value = dataValue
            } else {
              value = dataValue || ''
            }
          } else {
            value = i.text
          }
          elementString = `<div style="position: absolute; width: ${i.width}px; height: ${i.height}px; left: ${i.x}px; top: ${i.y}px;font-size: ${i.fontSize}px; font-weight: ${i.bold ? 'bold': 'normal'}; line-height: ${i.lineHeight}px;word-break:break-all;background-color: ${i.backColor ? '#000' : 'transparent'}; color: ${i.backColor ? '#fff' : '#000'}; text-align: ${i.textAlign || 'left'};">${value}</div>`
        } else if (_specialTypes.includes(type)) {
          // 特殊类型，目前只有list
          let value = ''
          if (type === 'list') {
            if (Object.keys(d).length) {
              value = d[i.key] || []
            } else {
              value = i.list || []
            }
            
            let listHtml = ''
            value.forEach(i => {
              listHtml += `<div style="display:flex;justify-content: space-between;"><span>${i.name || ''}:</span><span>${i.number || 0}</span></div>`
            })

            elementString = `<div style="position: absolute; width: ${i.width}px; height: ${i.height}px; left: ${i.x}px; top: ${i.y}px;font-size: ${i.fontSize}px; font-weight: ${i.bold ? 'bold': 'normal'}; line-height: ${i.lineHeight}px;word-break:break-all;overflow: hidden;background-color: ${i.backColor ? '#000' : 'transparent'}; color: ${i.backColor ? '#fff' : '#000'}">${listHtml}</div>`
          }
        }

        pageString += elementString
      })

      string += `<div style="padding:0;margin:0;width:${w}px;height:${h}px;overflow:hidden;position:relative;">${pageString}</div>`
    })

    return string
  },
  _extractDataValue(item, key) {
    // 提取字段中数据
    if (key.includes('.')) {
      const keyArrs = key.split('.').map(i => `['${i}']`).join('')
      try {
        return eval(`item${keyArrs}`)
      } catch(error) {
        console.log(`接口数据读取出错，未能获取字段：${key}, ${item}${keyArrs}`)
        console.error(error)
      }
    } else {
      return item[key]
    }
  },
}